import React, { useState, useEffect } from 'react';
import { noticeService } from '../../services/noticeService';

const NoticeManager = () => {
  const [notices, setNotices] = useState([]); // 초기 빈 배열로 .map 에러 방지
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ 
    title: '', content: '', author: '관리자', isImportant: false, isVisible: true 
  });

  const refresh = async () => {
    setLoading(true);
    try {
      const data = await noticeService.getNotices();
      setNotices(data || []);
    } catch (error) {
      console.error("공지 로드 실패", error);
    }
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const onSave = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.content) return alert("제목과 내용을 입력해주세요.");
    
    setLoading(true);
    try {
      if (editId) {
        await noticeService.updateNotice(editId, formData);
      } else {
        await noticeService.addNotice(formData);
      }
      setEditId(null);
      setFormData({ title: '', content: '', author: '관리자', isImportant: false, isVisible: true });
      await refresh();
      alert("✅ 공지사항이 처리되었습니다.");
    } catch (error) {
      alert("처리 중 오류가 발생했습니다.");
    }
    setLoading(false);
  };

  const handleToggleVisible = async (id) => {
    setLoading(true);
    await noticeService.toggleVisibility(id);
    await refresh();
    setLoading(false);
  };

  const onDelete = async (id) => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      await noticeService.deleteNotice(id);
      await refresh();
    }
  };

  const inputStyle = { width: '100%', padding: '12px', marginTop: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '13px', fontWeight: 'bold', color: '#475569', display: 'block' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
      <section style={{ padding: '30px', background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b', borderBottom: '1px solid #f1f5f9', paddingBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '25px' }}>
          <span style={{fontSize: '24px'}}>📢</span>
          {editId ? '공지사항 수정' : '신규 공지사항 등록'}
        </h3>
        <form onSubmit={onSave}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-end' }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>공지 제목</label>
                <input value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} style={inputStyle} placeholder="제목 입력" />
              </div>
              <div style={{ width: '150px', paddingBottom: '10px' }}>
                <label style={{...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                  <input type="checkbox" checked={formData.isImportant} onChange={e => setFormData({...formData, isImportant: e.target.checked})} />
                  중요 공지 필독
                </label>
              </div>
            </div>
            <div>
              <label style={labelStyle}>공지 내용</label>
              <textarea value={formData.content} onChange={e => setFormData({...formData, content: e.target.value})} style={{ ...inputStyle, height: '100px', resize: 'none' }} placeholder="상세 내용 입력" />
            </div>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button type="submit" disabled={loading} style={{ padding: '12px 50px', background: '#0d6ba1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                {loading ? '처리 중...' : (editId ? '수정 완료' : '공지사항 등록')}
              </button>
            </div>
          </div>
        </form>
      </section>

      <section style={{ padding: '25px', background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b', marginBottom: '25px' }}>✅ 게시물 관리 (Cloud)</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#f8fafc', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>
              <th style={{ padding: '15px' }}>노출 제어</th>
              <th style={{ padding: '15px' }}>제목 / 내용 요약</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>관리</th>
            </tr>
          </thead>
          <tbody>
            {notices.map(n => (
              <tr key={n.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '15px' }}>
                  <button onClick={() => handleToggleVisible(n.id)} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', background: n.isVisible ? '#e6fffa' : '#f1f5f9', color: n.isVisible ? '#0694a2' : '#94a3b8' }}>
                    {n.isVisible ? '● 노출중' : '○ 숨김'}
                  </button>
                </td>
                <td style={{ padding: '15px' }}>
                  <div style={{ fontWeight: 'bold' }}>{n.isImportant && <span style={{color:'red'}}>[중요] </span>}{n.title}</div>
                  <div style={{ fontSize: '11px', color: '#94a3b8' }}>{n.content?.substring(0, 50)}...</div>
                </td>
                <td style={{ padding: '15px', textAlign: 'center' }}>
                  <button onClick={() => {setEditId(n.id); setFormData({...n})}} style={{ color: '#0d6ba1', background: 'none', border: 'none', cursor: 'pointer', marginRight: '10px' }}>수정</button>
                  <button onClick={() => onDelete(n.id)} style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}>삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default NoticeManager;